import React from 'react'
import Routing from './routing/Routing'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'primeicons/primeicons.css';
import { RedirectProvider } from './context/redirectContext';
const App = () => {
  return (
    <>
    <RedirectProvider>
    <ToastContainer 
    style={{
      fontSize:"1.6rem"
    }}
    />
    <Routing />
    </RedirectProvider>
    </>
  )
}

export default App